export default "__VITE_ASSET__BxXKxSDD__"